import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { ReactElement } from 'react';
import { AUTHENTICATE } from 'graphql/auth/queries/authCallback';
import { Buffer } from 'buffer';
import Loading from 'components/Messages/Loading/Loading';
import Error from 'components/Messages/Error/Error';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from 'context/auth.context';

const Callback = (): ReactElement => {
  const [searchParams] = useSearchParams();
  const { login } = useAuthContext();
  const code = searchParams.get('code');
  const state = searchParams.get('state');
  const stateObject = state ? JSON.parse(Buffer.from(state, 'base64').toString()) : {};
  const navigate = useNavigate();

  const { loading, error, data } = useQuery(AUTHENTICATE, {
    variables: { code: code, state: state },
  });

  useEffect(() => {
    if (data) {
      login(data.getToken, stateObject.destination);
    }
  }, [data, login, navigate, stateObject.destination]);

  if (loading) {
    return <Loading />;
  }
  if (error) {
    return <Error message={error.message} />;
  }

  return <></>;
};

export default Callback;
